/**
 * Applies a favicon URL to the document.
 * Use this whenever PropertyLogoUrl is available so the favicon shows on first load
 * and persists on navigation and refresh.
 */
export function applyFavicon(url: string): void {
  if (!url || typeof document === 'undefined') return;
  try {
    const existingFavicon =
      document.querySelector('link[rel="icon"]') ||
      document.querySelector('link[rel="shortcut icon"]');
    if (existingFavicon) {
      (existingFavicon as HTMLLinkElement).href = url;
    } else {
      const favicon = document.createElement('link');
      favicon.rel = 'icon';
      favicon.type = 'image/x-icon';
      favicon.href = url;
      document.head.appendChild(favicon);
    }
  } catch (e) {
    console.warn('Failed to apply favicon:', e);
  }
}
